import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import styles from '../Table/Table.module.scss';
import { Icon, Text } from '../index';
import { getIconUrl } from '../../lib/helpers/mediaHeplers';
import { BACKGROUND_COLORS, BREAKPOINT_MOBILE } from '../../lib/constants';
import useBreakpoint from '../../lib/helpers/useBreakpoint';

const Table = (props) => {
    const { tableText, tableTextColor, tableHead, rows, addBorder, layout } = props;

    const isVermilion = (color) => {
        return color === BACKGROUND_COLORS[3] ? true : false;
    };

    const currentBreakpoint = useBreakpoint();
    const layoutStyle = currentBreakpoint === BREAKPOINT_MOBILE ? 'one-line' : layout;

    const tableHeaders = tableHead
        ? tableHead.map((tableHead, index) => (
              <th key={index}>
                  <div className={cx(styles['table--head'])}>
                      {tableHead.iconHead && (
                          <Icon
                              url={getIconUrl(tableHead.iconHead)}
                              size={tableHead.iconSizeHead}
                              className={styles['table-icon']}
                          />
                      )}
                      {tableHead.headText && (
                          <Text
                              className={cx(
                                  styles['table-text'],
                                  isVermilion(tableHead.headTextColor) &&
                                      styles['table-text--vermilion']
                              )}
                              content={tableHead.headText}
                          />
                      )}
                  </div>
              </th>
          ))
        : null;

    const tableRows = rows
        ? rows.map((rowData, index) =>
              rowData ? (
                  <tr key={index}>
                      {rowData.row.map(({ rowText, rowTextColor, iconRow, iconSizeRow }) => (
                          <td>
                              {iconRow && (
                                  <Icon
                                      url={getIconUrl(iconRow)}
                                      size={iconSizeRow}
                                      className={styles['table-icon']}
                                  />
                              )}
                              {rowText && (
                                  <Text
                                      className={cx(
                                          styles['table-text'],
                                          isVermilion(rowTextColor) &&
                                              styles['table-text--vermilion']
                                      )}
                                      content={rowText}
                                  />
                              )}
                          </td>
                      ))}
                  </tr>
              ) : null
          )
        : null;

    return (
        <table
            className={cx(
                styles['table'],
                styles[`table--${layoutStyle}`],
                addBorder && styles['table--border']
            )}
        >
            <tbody>
                <tr>
                    <th>
                        {tableText && (
                            <Text
                                className={cx(
                                    styles['table-text'],
                                    isVermilion(tableTextColor) && styles['table-text--vermilion']
                                )}
                                content={tableText}
                            />
                        )}
                    </th>
                    {tableHeaders}
                </tr>
                {tableRows}
            </tbody>
        </table>
    );
};

Table.displayName = 'Table';

Table.propTypes = {
    tableText: PropTypes.string,
    tableTextColor: PropTypes.string,
    addBorder: PropTypes.bool.isRequired,
    layout: PropTypes.oneOf(['one-line', 'automatic-width', 'same-width']),
};

Table.defaultProps = {
    layout: 'one-line',
};

export default Table;
